import React, { useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { dataApi } from '../../services/dataApi'; 

function CreatePdf({ userData, onSuccess = () => {}, disabled = false }) {
  const [loading, setLoading] = useState(false);

  const handleCreate = async () => {
    if (loading || !userData) return;

    try {
      setLoading(true);

      const result = await dataApi.downloadPdf(userData); 

      if (result && result.url) {
        // Just pass the URL up. Do NOT download here.
        onSuccess(result.url); 
      } else {
        throw new Error('API returned successfully but no download URL was provided.');
      }
    } catch (err) {
      console.error('PDF generation failed:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      variant="contained"
      color="primary"
      disabled={disabled || loading}
      onClick={handleCreate}
      startIcon={
        loading ? <CircularProgress size={18} color="inherit" /> : <DownloadIcon />
      }
      sx={{ minWidth: 140 }}
    >
      {loading ? 'Generating…' : 'Export PDF'}
    </Button>
  );
}

export default CreatePdf;